/* HD File Uploader (Make.com webhook) — multi-file dropzone
   Creates numbered hidden inputs: contact[file_link1], contact[file_link2], …
   Looks for .hd-fileuploader widgets (snippet: file-upload-make.liquid)
   Exposes: window.initHDFileUploader(scope)
*/
window.initHDFileUploader = function(scope){
  scope = scope || document;
  const widgets = scope.querySelectorAll('.hd-fileuploader');

  widgets.forEach((wrap) => {
    if (wrap.__hdBound) return;
    wrap.__hdBound = true;

    const webhook    = wrap.dataset.webhook || '';
    const prefix     = wrap.dataset.prefix  || 'contact[file_link]'; // TRAILING ']' expected
    const multiple   = wrap.dataset.multiple === 'true';
    const maxFiles   = parseInt(wrap.dataset.maxFiles || '5', 10);
    const accept     = (wrap.dataset.accept || '').toLowerCase();
    const maxSizeMB  = parseInt(wrap.dataset.maxSizeMb || '25', 10);
    const required   = wrap.dataset.required === 'true';

    const drop  = wrap.querySelector('.hd-fu-drop');
    const input = wrap.querySelector('.hd-fu-input');
    const list  = wrap.querySelector('.hd-fu-list');
    const form  = wrap.closest('form');

    // ---------- Numbered-name helpers: contact[file_link1], … ----------
    // Be robust if merchant forgets the trailing bracket.
    const baseStart = prefix.endsWith(']') ? prefix.slice(0, -1) : prefix; // "contact[file_link"
    const esc = (s) => s.replace(/[[\]()*+?.\\^$|]/g, '\\$&');
    const nameRe = new RegExp('^' + esc(baseStart) + '(\\d+)\\]$');

    function getNextIndexFromDOM(){
      if (!form) return 1;
      let max = 0;
      form.querySelectorAll(`input[type="hidden"][name^="${baseStart}"]`).forEach(inp => {
        const m = inp.name.match(nameRe);
        if (m && m[1]) max = Math.max(max, parseInt(m[1], 10));
      });
      return max + 1;
    }
    function numberedName(i){ return `${baseStart}${i}]`; } // -> contact[file_link1]

    // -------------------------------------------------------------------
    const bytesMB = (b) => b / 1024 / 1024;
    const sanitizeName = (s) => s.replace(/[^\x20-\x7E]/g,'').slice(0,180);

    function addListItem(file){
      const li = document.createElement('li');
      li.className = 'hd-fu-item';
      li.innerHTML = `
        <div class="hd-fu-row">
          <div class="hd-fu-fn" title="${sanitizeName(file.name)}">${sanitizeName(file.name)}</div>
          <div class="hd-fu-actions">
            <button type="button" class="hd-fu-btn hd-fu-cancel" aria-label="Cancel upload">✕</button>
          </div>
        </div>
        <div class="hd-fu-status">Queued…</div>
        <div class="hd-fu-bar"><span></span></div>
      `;
      list.appendChild(li);
      return li;
    }

    function createHiddenInput(name, url){
      if (!form) return null;
      const h = document.createElement('input');
      h.type  = 'hidden';
      h.name  = name;
      h.value = url;
      h.dataset.hdFu = '1';
      form.appendChild(h);
      return h;
    }

    function clearHiddenInputs(){
      if (!form) return;
      form.querySelectorAll('input[type="hidden"][data-hd-fu="1"]').forEach(n => n.remove());
    }

    function validateFiles(files){
      const arr = Array.from(files);
      const errors = [];
      const existing = list.querySelectorAll('.hd-fu-item[data-state="ok"]').length;
      if (existing + arr.length > maxFiles) errors.push(`You can upload up to ${maxFiles} files.`);
      arr.forEach(f => {
        if (bytesMB(f.size) > maxSizeMB) errors.push(`${f.name}: exceeds ${maxSizeMB}MB`);
        if (accept) {
          const exts = accept.split(',').map(s => s.trim());
          const fn = f.name.toLowerCase();
          const ok = exts.some(ext => {
            if (ext.startsWith('.')) return fn.endsWith(ext);
            if (ext.endsWith('/*'))  return (f.type || '').startsWith(ext.replace('/*','/'));
            return false;
          });
          if (!ok) errors.push(`${f.name}: file type not allowed`);
        }
      });
      return { valid: errors.length === 0, errors, files: arr };
    }

    function uploadWithProgress(file, onProgress){
      return new Promise((resolve, reject) => {
        if (!webhook) return reject(new Error('Webhook URL missing'));
        const xhr = new XMLHttpRequest();
        xhr.open('POST', webhook, true);
        xhr.upload.onprogress = (evt) => {
          if (evt.lengthComputable) onProgress(Math.round((evt.loaded / evt.total) * 100));
        };
        xhr.onreadystatechange = () => {
          if (xhr.readyState !== 4) return;
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const json = JSON.parse(xhr.responseText || '{}');
              if (json && json.url) resolve(json.url);
              else reject(new Error('No URL in response'));
            } catch(e){ reject(new Error('Invalid JSON response')); }
          } else {
            reject(new Error('Upload failed'));
          }
        };
        const fd = new FormData();
        fd.append('contact[file]', file, file.name);
        xhr.send(fd);
      });
    }

    async function handleFiles(selected){
      const { valid, errors, files } = validateFiles(selected);
      if (!valid) { alert(errors.join('\n')); return; }

      if (!multiple) { list.innerHTML = ''; clearHiddenInputs(); }

      // Seed once per selection to avoid duplicate numbers across async completions
      let nextIndex = getNextIndexFromDOM();

      files.forEach((file) => {
        const li = addListItem(file);
        const statusEl  = li.querySelector('.hd-fu-status');
        const bar       = li.querySelector('.hd-fu-bar > span');
        const cancelBtn = li.querySelector('.hd-fu-cancel');
        let cancelled   = false;
        let hiddenInput = null;

        cancelBtn.addEventListener('click', () => {
          cancelled = true;
          li.remove();
          if (hiddenInput) hiddenInput.remove();
          if (!multiple) clearHiddenInputs();
        }, { once:true });

        statusEl.textContent = 'Uploading…';
        li.dataset.state = 'uploading';

        uploadWithProgress(file, (pct) => { if (!cancelled) bar.style.width = pct + '%'; })
          .then((url) => {
            if (cancelled) return;
            const name = numberedName(nextIndex++);
            hiddenInput = createHiddenInput(name, url);
            li.dataset.state = 'ok';
            statusEl.textContent = 'Uploaded';
            statusEl.classList.add('ok');
            bar.style.width = '100%';
            const actions = li.querySelector('.hd-fu-actions');
            actions.innerHTML = '<button type="button" class="hd-fu-btn hd-fu-remove" aria-label="Remove file">Remove</button>';
            actions.querySelector('.hd-fu-remove').addEventListener('click', () => {
              li.remove();
              if (hiddenInput) hiddenInput.remove();
            });
          })
          .catch((err) => {
            if (cancelled) return;
            li.dataset.state = 'err';
            statusEl.textContent = err && err.message ? err.message : 'Upload failed';
            statusEl.classList.add('err');
            bar.style.width = '0%';
          });
      });
    }

    // Drag & drop + input
    ['dragenter','dragover'].forEach(ev => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.style.borderColor = '#999'; }));
    ['dragleave','drop'].forEach(ev => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.style.borderColor = ''; }));
    drop.addEventListener('drop', (e) => {
      const dt = e.dataTransfer; e.preventDefault();
      if (dt && dt.files && dt.files.length) handleFiles(dt.files);
    });
    input.addEventListener('change', (e) => {
      if (e.target.files && e.target.files.length) handleFiles(e.target.files);
      e.target.value = '';
    });

    // Required guard
    if (required && form) {
      form.addEventListener('submit', (e) => {
        const ok = form.querySelector(`input[type="hidden"][name^="${baseStart}"]`);
        if (!ok) { e.preventDefault(); alert('Please upload at least one file.'); }
      });
    }
  });
};

// Auto-init + re-init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.initHDFileUploader(document));
} else {
  window.initHDFileUploader(document);
}
document.addEventListener('shopify:section:load', (e) => window.initHDFileUploader(e.target));
